import { serializeParams } from "./request"

export function getParam(name, url) {
  let src = url || window.location.href
  if (name && src) {
    var r = new RegExp("(\\?|#|&|^)" + name + "=([^&^#]*)(#|&|$)")
    var m = src.match(r)
    return !m ? "" : decodeURIComponent(m[2])
  }
  return ""
}

/**
 * 删除url上的参数(支持hash)
 * @param {*} name 参数名(支持数组)
 * @param {*} url url
 */
export function delParam(name, url) {
  if (!(name instanceof Array)) {
    name = [name]
  }

  name.forEach(function(v) {
    url = url.replace(new RegExp("(?:&" + v + "=[^&#]*)", "g"), "")
    url = url.replace(new RegExp("(?:\\?" + v + "=[^&#]*&?)", "g"), "?")
  })
  return url
}

/**
 * 在 url 上添加参数
 * eg: addParam({pf: '__mds_wx_other'}, url)
 * @param arr
 * @param url
 * @return {string|*}
 */
export function addParam(arr, url) {
  var names = Object.keys(arr)

  url = delParam(names, url)
  var postfix = serializeParams(arr)
  url += /(\?|&)$/.test(url) ? "" + postfix : /\?/.test(url) ? "&" + postfix : "?" + postfix
  return url
}

/**
 * 给 url 上增加参数（支持 hash）
 * 参数与 addParam 相同
 * @param arr
 * @param url
 * @return {*}
 */
export function addGetParam(arr, url) {
  // 取出 hash 第一段 & 第二段
  let [prefix, suffix] = url.split("#")

  // 给第一段增加参数
  let addedUrl = addParam(arr, prefix)

  // 若存在第二段，则拼接后返回
  if (suffix) {
    return [addedUrl, "#", suffix].join("")
  }

  return addedUrl
}
